import facebook from '@/images/socials/facebook.svg';
import whatsapp from '@/images/socials/whatsapp.svg';
import { FilterCategoryType } from './types';
import { Route } from 'next';

export interface NavigationItemInterface {
  id: string;
  href?: string;
  name: string;
  sub_categories?: NavigationItemInterface[];
}
export interface CustomLink {
  label: string;
  href: Route;
  targetBlank?: boolean;
}

export interface WidgetFooterMenu {
  id: string;
  title: string;
  menus: CustomLink[];
}


// export const NAVIGATION_DATA:NavigationItemInterface[] = [
//   {
//     id: "1",

//     name: "Krishna mohon das",

//     sub_categories: [
//       {
//         id: "2",
//         href: "/Santosh",
//         name: "Santosh",

//         sub_categories: [
//           {
//             id: "3",
//             href: "/Rony",
//             name: "Rony",

//             sub_categories: [],
//           },
//           {
//             id: "4",
//             href: "/Nisha",
//             name: "Nisha",

//             sub_categories: [
//               {
//                 id: "5",
//                 href: "/Mehur",
//                 name: "Mehur",

//                 sub_categories: [],
//               },
//             ],
//           },
//         ],
//       },
//       {
//         id: '644',
//         href: '/Bashie',
//         name: 'Bashie',

//         sub_categories: [],
//       },
//     ],
//   },
//   {
//     id: '7',

//     name: 'Categories',

//     sub_categories: [],
//   },
//   {
//     id: '8',

//     name: 'Zugarnath',

//     sub_categories: [
//       {
//         id: '9',
//         href: '/Aditye',
//         name: 'Aditye',

//         sub_categories: [
//           {
//             id: '10',
//             href: '/Aditye-not-m',
//             name: 'Aditye not Merried',

//             sub_categories: [],
//           },
//           {
//             id: '11',
//             href: '/Aditye2-not-merried',
//             name: 'Aditye2 not Merried',

//             sub_categories: [],
//           },
//         ],
//       },
//       {
//         id: '12',
//         href: '/Adite2',
//         name: 'Adite2',

//         sub_categories: [],
//       },
//     ],
//   },
// ];

export const NAVIGATION_DATA: NavigationItemInterface[] = [
  {
    id: '1',
    name: 'Cricket',
    sub_categories: [
      {
        id: '1',
        href: '/ipl',
        name: 'IPL',
        sub_categories: [],
      },
      {
        id: '2',
        href: '/psl',
        name: 'PSL',
        sub_categories: [],
      },
    ],
  },
  {
    id: '2',
    name: 'Betting Sites',
    sub_categories: [
      {
        id: '1',
        href: '/bet365',
        name: 'Bet365',
        sub_categories: [],
      },
      {
        id: '2',
        href: '/betfair',
        name: 'Betfair',
        sub_categories: [],
      },
    ],
  },
  {
    id: '3',
    name: 'Online Casinos',
    sub_categories: [],
  },
  {
    id: '4',
    name: 'Cryptocurrency',
    sub_categories: [
      {
        id: '1',
        href: '/binance',
        name: 'Binance',

        sub_categories: [],
      },
    ],
  },
];

export const socials = [

  { 
    href: 'https://www.facebook.com/bethelp24/',
    icon: facebook,
    name: 'Facebook',
  },
  { 
    href: "https://wa.me/8801716401247",
    icon: whatsapp,
    name: 'WhatsApp'
  }
];

export const categories: FilterCategoryType[] = [
  { label: 'Latest', tag: 'latest' },
  { label: 'Cricket', tag: 'cricket' },
  { label: 'IPL', tag: 'ipl' },
  { label: 'PSL', tag: 'psl' },

];

export const bethelp24_bucket = 'bethelp24-bucket';

export const widgetMenus: WidgetFooterMenu[] = [
  {
    id: "1",
    title: "Getting started",
    menus: [
      { href: "/register", label: "Sing up" },
      { href: "/login", label: "Sign in" },
    ],
  },
  {
    id: "2",
    title: "Company",
    menus: [
      { href: "/about", label: "About Us" },
      { href: "/contact", label: "Contact Us" },
      { href: "/privacy-policy", label: "Privacy Policy" },
      { href: "/terms-conditions", label: "Terms & Conditions" },
    ],
  },
  {
    id: "3",
    title: "Customer Service",
    menus: [
      { href: "https://wa.me/8801323967633", label: "Sport Prediction Group" },
      { href: "#", label: "API Reference" },
    ],
  },

];
